// Решение человека о передаче данных AI-сервисам — чтение и запись.
//
// Источник правды — сервер (`users.ai_data_sharing`, применяется в швах
// AI-портов). Хук не держит своей копии: читает `auth.me` и после записи
// перечитывает его, чтобы экран разрешения, переключатель в «Приватности» и
// ответы сервера говорили одно и то же.

import { useCallback } from "react";
import { api } from "@/lib/trpc-client";
import { useAuth } from "@/providers/auth-provider";

export type AiDataSharingDecision = "granted" | "denied";

export interface UseAiDataSharing {
	/** `undefined` — ещё не знаем (офлайн, загрузка); `null` — не спрашивали. */
	decision: AiDataSharingDecision | null | undefined;
	decide: (decision: AiDataSharingDecision) => Promise<void>;
	isSaving: boolean;
}

export function useAiDataSharing(): UseAiDataSharing {
	const { user, refresh } = useAuth();
	const utils = api.useUtils();
	const mutation = api.users.setAiDataSharing.useMutation();

	const decide = useCallback(
		async (decision: AiDataSharingDecision): Promise<void> => {
			await mutation.mutateAsync({ decision });
			await Promise.all([utils.auth.me.invalidate(), refresh()]);
		},
		[mutation, utils, refresh],
	);

	return {
		decision: user?.aiDataSharing,
		decide,
		isSaving: mutation.isPending,
	};
}
